module.exports = "/_next/static/images/d5fca72d2d73ed89957a15ef183e247a-credit-card-autonomy@0.75x.png";